import React from 'react';
import genStyles from '../generale.module.css';
import CollectionService from '../../service/CollectionService';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { activeformEditEntiteState, activeformNewEntiteState, apiCollectionState, collectionsCurState, collectionsState, idDataEntityState, idLayerEditState, loadingState, localDataState, reloadCollectionState, toastState, userDataState } from '../../atoms/CollectionState';
import DrawService from '../../service/DrawService';


export default function DeleteCollectionForm({ onClose, objectCur, type, setEntites,reloadSharedCollection }) {
    const api_collection = useRecoilValue(apiCollectionState);
    const user_data = useRecoilValue(userDataState);     
    const setCollections = useSetRecoilState(collectionsState);        
    const setToast = useSetRecoilState(toastState);  
    const setLayerEdit = useSetRecoilState(idLayerEditState);     
    const  setActiveEdit = useSetRecoilState(activeformEditEntiteState);
    const setActiveNew = useSetRecoilState(activeformNewEntiteState);
    const setLoading = useSetRecoilState(loadingState);
    const itemcurrentCollection = useRecoilValue(collectionsCurState);  
    const setReloadCollection = useSetRecoilState(reloadCollectionState);
    const LocalData = useRecoilValue(localDataState);
    const iddCollectionSelected = useRecoilValue(idDataEntityState);
      
    
    const onValidate = () => {  
        if(type === 'collection'){
            deleteCollection();
        }else if(type === 'entity'){
            deleteEntity();
        }else if(type === 'duplicate'){
           duplicate();
        }else if(type === 'unshare'){
            unshareCollection();
        }else if(type === 'file'){
            deleteFile();
        }else if(type === 'deleteallentity'){
            deleteSelectedEntity();
        }else if(type === 'entityForFile'){
            deleteEntityForFileList();
        }else if(type === 'deleteallentityForFile'){
            deleteEntityForFileList();
        }          
        
    };

    const unshareCollection = () => {
        setLoading(true); 
        const data = {
            account_id: objectCur.account_id,
            add:false,
            collection_id:objectCur.collection_id,
            delete:false,
            edit:false,
            owner:objectCur.owner,
            read:false,
            user_id:objectCur.user_id,
        };
        
        const api = api_collection+ user_data.account.port+ '/';

        CollectionService.shareUnshareCollection(api, objectCur.account_id,objectCur.collection_id,data).then((response) => {
            if(response.rows){
                setToast({ message: response.message , type: 'success' }); 
                reloadSharedCollection();               
            }else{
                setToast({ message: response.message , type: 'error' });
            }
            setLoading(false);   
            onClose();      
        });      
    };

    const duplicate = () => {
        const api = api_collection+ user_data.account.port+ '/';
        const userId = user_data.user.id;
        setLoading(true);     
        CollectionService.duplicateCollection(api,userId,objectCur.id).then((response) => { 
            setToast({ message: response.message , type: 'success' });  
            setReloadCollection(true);
            onClose();         
            
        }); 
    };

    const deleteCollection = () => { 
        const api = api_collection+ user_data.account.port+ '/';
        const userId = user_data.user.id;
        setLoading(true);     
        CollectionService.deleteCollection(api,userId,objectCur.id).then((response) => { 
            if(response.rows){
                setToast({ message: response.message , type: 'success' });                
                setCollections((prev) => prev.filter((item) => item.id !== objectCur.id));
                DrawService.removeLayerCollection(objectCur,'collection');
            }else{
                setToast({ message: response.message , type: 'error' });                
            }        
            setLoading(false);     
            onClose();         
            
        }); 
    };

    const deleteEntity = () => {   
        //suppression au niveau base de donnée        
        if(!LocalData){      
            const api = api_collection+ user_data.account.port+ '/';
            const userId = user_data.user.id;
            setLoading(true);     
            let identite = objectCur.id;
            if(objectCur.idnewbd)identite = objectCur.idnewbd;
            CollectionService.deleteEntityFromCollection(api,userId,objectCur.collection_id,identite).then((response) => { 
                if(response.rows){
                    setToast({ message: response.message , type: 'success' });                        
                    setCollections(prev =>
                        prev.map(col => {
                            if (col.id === itemcurrentCollection.id) {
                                const oldFeatures = Array.isArray(col.geojson?.features) ? col.geojson.features : [];
                                const deletedId = identite; 
                                const newFeatures = oldFeatures.filter(
                                f => f.id !== deletedId && f.properties?.id !== deletedId
                                );
                        
                                return {
                                    ...col,
                                    nb_entite: Math.max(0, col.nb_entite - 1),
                                    geojson: {
                                        ...col.geojson,
                                        features: newFeatures,
                                    },
                                };
                            }
                          return col;
                        })
                    );
                                
                    deleteEntityList ();
                }else{
                    setToast({ message: response.message , type: 'error' });                
                }  
                setLoading(false);       
                onClose();         
                
            }); 
        }else{
            setToast({ message: "L'entité a été supprimée" , type: 'success' });
            deleteEntityList();
            setLoading(false);       
            onClose();         
        }
    };

    const deleteEntityList = (aid = null) => {
        const collection = aid || { id: objectCur.id };
        if(!LocalData){
            reloadDataCollectionlist();    
            setReloadCollection(true);
        }else{
            setEntites((prev) => prev.filter((item) => item.id !== objectCur.id));
        }  
        setLayerEdit(null);
        DrawService.removeLayerCollection(collection, 'entity');
        DrawService.desactiveEdition();
        setActiveNew(false);
        setActiveEdit(false);
    };

    const deleteFile = () => {
        const api = api_collection+ user_data.account.port+ '/';
        const userId = user_data.user.id;
        setLoading(true);     
        CollectionService.deleteFileFromEntite(api,userId,objectCur.id,objectCur.sha1).then((response) => { 
            if(response.rows){
                setToast({ message: response.message , type: 'success' });    
            }else{
                setToast({ message: response.message , type: 'error' });                
            }        
            setLoading(false);     
            onClose();         
            
        }); 
    };

    const reloadDataCollectionlist = () => {
        const api = api_collection+ user_data.account.port+ '/';
        const userId = user_data.user.id;
        CollectionService.fetchCollectionList(api, userId,iddCollectionSelected).then((response) => {
             setEntites(response);          
        });
    };

    const deleteSelectedEntity = () => {
        //suppression au niveau base de donnée        
       if(!LocalData){      
           const api = api_collection+ user_data.account.port+ '/';
           const userId = user_data.user.id;
           setLoading(true);     
           // Normaliser objectCur (un ou plusieurs objets)
           const entitiesToDelete = Array.isArray(objectCur) ? objectCur : [objectCur];
            // Récupérer les IDs à supprimer
           const ids = entitiesToDelete.map((entity) => entity.idnewbd ?? entity.id);
           const collectionId = entitiesToDelete[0]?.collection_id; // même collection

           CollectionService.deleteMultiEntityFromCollection(api,userId,collectionId,ids).then((response) => { 
               if(response.rows){
                   setToast({ message: response.message , type: 'success' });
                   // Mettre à jour le compteur
                   setCollections((prev) =>
                       prev.map((col) =>
                       col.id === itemcurrentCollection.id
                           ? { ...col, nb_entite: col.nb_entite - ids.length }
                           : col
                       )
                   );  
                   deleteEntityList (ids);
               }else{
                   setToast({ message: response.message , type: 'error' });                
               }  
               setLoading(false);       
               onClose();         
               
           }); 
       }else{
           setToast({ message: "Les entités sélectionnées ont été supprimées." , type: 'success' });
           deleteEntityList();
           setLoading(false);       
           onClose();         
       }
   };
   
   const deleteEntityForFileList = () => {      
        // Normaliser : si objectCur est un tableau ou un objet
        const entitiesToDelete = Array.isArray(objectCur) ? objectCur : [objectCur];

        // Supprimer du state React
        setEntites((prev) =>
            prev.filter((item) => !entitiesToDelete.some((obj) => obj.id === item.id))
        );

        // Supprimer du service DrawService
        entitiesToDelete.forEach((entity) => {
            const collection = { id: entity.id };
            DrawService.removeLayerCollection(collection, "entity");           
            DrawService.clearHighlight(entity.id);
        });

        setLayerEdit(null);
        onClose();  
    };

    const destructiveTypes = ["collection", "entity", "unshare", "file", "deleteallentity", "entityForFile", "deleteallentityForFile"];
    const isDestructive = destructiveTypes.includes(type);

    return (
        <div className="row mb0">
            <div className="col s12 mb20">
                <div className={`${genStyles.modalConfirmIcon} ${isDestructive ? genStyles.modalConfirmIconDanger : genStyles.modalConfirmIconInfo}`}>
                    <i className={`fa-solid ${isDestructive ? 'fa-triangle-exclamation' : 'fa-circle-info'}`}></i>
                </div>
                <p className={genStyles.modalConfirmText}>
                {type === "collection" ? (
                <>
                    Êtes-vous sûr de vouloir <b className="red-text">supprimer</b> la collection{" "}
                    <span className="uppercase bold"><b>{objectCur.nom_affiche}</b></span> ?
                </>
                ) : type === "entity" ? (
                <>
                    Êtes-vous sûr de vouloir <b className="red-text">supprimer</b> cette entité ?
                </>
                ) : type === "duplicate" ? (
                <>
                    Êtes-vous sûr de vouloir <b className="red-text">dupliquer</b> la collection{" "}
                    <span className="uppercase bold"><b>{objectCur.nom_affiche}</b></span> ?
                </>
                ) : type === "unshare" ? (
                    <>
                        Êtes-vous sûr de vouloir <b className="red-text">annuler</b> le partage de la collection {" "}
                        <span className="uppercase"><b>{objectCur.nom_affiche}</b></span> ?
                    </>
                ) : type === "file" ? (
                    <>
                        Êtes-vous sûr de vouloir <b className="red-text">supprimer</b> le fichier {" "}
                        <span className="uppercase"><b>{objectCur.libelle}</b></span> ?
                    </>
                ) : type === "deleteallentity" ? (
                    <>
                        Êtes-vous sûr de vouloir <b className="red-text">supprimer</b> les entités sélectionnées ?
                    </>
                )  : type === "entityForFile" ? (
                    <>
                        Êtes-vous sûr de vouloir <b className="red-text">supprimer</b> cette entité  ?
                    </>
                )  : type === "deleteallentityForFile" ? (
                    <>
                        Êtes-vous sûr de vouloir <b className="red-text">supprimer</b> les entités sélectionnées ?
                    </>
                ) : null}

                </p>
            </div>
            <div className="col s12">
                <div className={genStyles.modalActions}>
                    <button
                    className={`${genStyles.modalBtn} ${genStyles.modalBtnSecondary}`}
                    onClick={onClose}
                    >
                    Annuler
                    </button>
                    <button
                    className={`${genStyles.modalBtn} ${isDestructive ? genStyles.modalBtnDanger : genStyles.modalBtnPrimary}`}
                    onClick={onValidate}
                    >
                    Valider
                    </button>
                </div>
            </div>
        </div>
    );
}
